import { Course } from '../context/CourseContext'
export const courseData: Course[] = [
  {
    id: '1',
    title: 'Transferable Skills of Education Graduates',
    description:
      "Discover the valuable skills you've developed through your education degree that are highly sought after in the modern workplace.",
    thumbnail:
      'https://images.unsplash.com/photo-1523240795612-9a054b0db644?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    isRequired: true,
    isSuggested: false,
    modules: [
      {
        id: 'm1-1',
        title: 'Communication & Presentation Skills',
        content: {
          video: 'https://example.com/video1',
          text: "As an education graduate, you've developed exceptional communication skills through presenting lessons, explaining complex concepts, and adapting your communication style to different audiences. These skills are highly valued in roles such as corporate training, public relations, and management...",
          resources: [
            { name: 'Communication Skills Assessment', url: '#' },
            { name: 'Presentation Skills Portfolio Guide', url: '#' },
          ],
        },
      },
      {
        id: 'm1-2',
        title: 'Leadership & Group Management',
        content: {
          video: 'https://example.com/video2',
          text: 'Classroom management translates directly to team leadership in professional settings. Your ability to guide groups, resolve conflicts, and create collaborative environments makes you an ideal candidate for team leadership roles...',
          resources: [
            { name: 'Leadership Style Assessment', url: '#' },
            { name: 'Group Management Case Studies', url: '#' },
          ],
        },
      },
      {
        id: 'm1-3',
        title: 'Assessment & Analytical Skills',
        content: {
          video: 'https://example.com/video3',
          text: 'Your experience with assessment, data analysis, and progress tracking provides you with analytical skills that are valuable in research, data analysis, and program evaluation roles...',
          resources: [
            { name: 'Analytical Skills Workbook', url: '#' },
            { name: 'Data-Driven Decision Making Guide', url: '#' },
          ],
        },
      },
    ],
  },
  {
    id: '2',
    title: 'Corporate Training & Development',
    description:
      'Explore how your teaching skills can translate into a rewarding career in corporate learning and development.',
    thumbnail:
      'https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    isRequired: true,
    isSuggested: false,
    modules: [
      {
        id: 'm2-1',
        title: 'Introduction to Corporate L&D',
        content: {
          video: 'https://example.com/video4',
          text: 'Corporate Learning & Development (L&D) involves designing, delivering, and managing training programs that help employees develop skills and knowledge. As an education graduate, your understanding of learning processes and instructional methods makes you a natural fit for this field...',
          resources: [
            { name: 'L&D Industry Overview', url: '#' },
            { name: 'Corporate Training Job Profiles', url: '#' },
          ],
        },
      },
      {
        id: 'm2-2',
        title: 'Designing Corporate Training Programs',
        content: {
          video: 'https://example.com/video5',
          text: 'Learn how to adapt your curriculum design skills to create effective corporate training programs that address specific business needs and learning objectives...',
          resources: [
            { name: 'Training Needs Analysis Template', url: '#' },
            { name: 'Corporate Learning Program Design Guide', url: '#' },
          ],
        },
      },
      {
        id: 'm2-3',
        title: 'Measuring Training Effectiveness',
        content: {
          video: 'https://example.com/video6',
          text: 'Discover how to evaluate the impact of corporate training initiatives using metrics, assessments, and ROI calculations...',
          resources: [
            { name: 'Training Evaluation Models', url: '#' },
            { name: 'ROI Calculation Spreadsheet', url: '#' },
          ],
        },
      },
    ],
  },
  {
    id: '3',
    title: 'Instructional Design & eLearning',
    description:
      'Master the art of creating engaging digital learning experiences and build a career in the growing field of instructional design.',
    thumbnail:
      'https://images.unsplash.com/photo-1581291518633-83b4ebd1d83e?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    isRequired: true,
    isSuggested: false,
    modules: [
      {
        id: 'm3-1',
        title: 'Fundamentals of Instructional Design',
        content: {
          video: 'https://example.com/video7',
          text: 'Instructional design is the systematic process of creating effective learning experiences. This module explores key models like ADDIE and Backward Design, and how your education background provides an excellent foundation for this field...',
          resources: [
            { name: 'Instructional Design Models Guide', url: '#' },
            { name: 'Learning Objectives Framework', url: '#' },
          ],
        },
      },
      {
        id: 'm3-2',
        title: 'eLearning Development Tools',
        content: {
          video: 'https://example.com/video8',
          text: 'Explore popular tools and platforms used in creating digital learning content, including authoring tools, learning management systems, and multimedia development software...',
          resources: [
            { name: 'eLearning Tools Comparison', url: '#' },
            { name: "Beginner's Guide to Articulate Storyline", url: '#' },
          ],
        },
      },
      {
        id: 'm3-3',
        title: 'Building Your Instructional Design Portfolio',
        content: {
          video: 'https://example.com/video9',
          text: 'Learn how to showcase your instructional design skills through an effective portfolio that demonstrates your ability to create engaging learning experiences...',
          resources: [
            { name: 'Portfolio Development Checklist', url: '#' },
            { name: 'Sample Instructional Design Projects', url: '#' },
          ],
        },
      },
    ],
  },
  {
    id: '4',
    title: 'Educational Technology Careers',
    description:
      'Discover opportunities in the rapidly growing edtech sector and how your education background gives you a competitive edge.',
    thumbnail:
      'https://images.unsplash.com/photo-1526374965328-7f61d4dc18c5?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    isRequired: true,
    isSuggested: false,
    modules: [
      {
        id: 'm4-1',
        title: 'The Edtech Landscape',
        content: {
          video: 'https://example.com/video10',
          text: 'Explore the diverse educational technology sector, including learning platforms, assessment tools, educational apps, and virtual reality learning environments. Understand the market trends and growth areas in Africa and globally...',
          resources: [
            { name: 'African Edtech Market Report', url: '#' },
            { name: 'Edtech Career Paths Guide', url: '#' },
          ],
        },
      },
      {
        id: 'm4-2',
        title: 'Roles for Educators in Edtech',
        content: {
          video: 'https://example.com/video11',
          text: 'Discover the various roles educators can play in edtech companies, from content development and product testing to implementation training and customer success...',
          resources: [
            { name: 'Edtech Job Descriptions Analysis', url: '#' },
            { name: 'Skills Mapping Worksheet', url: '#' },
          ],
        },
      },
    ],
  },
  {
    id: '5',
    title: 'Educational Consulting & Curriculum Development',
    description:
      'Learn how to leverage your expertise to advise educational institutions, governments, and organizations on educational strategies.',
    thumbnail:
      'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    isRequired: false,
    isSuggested: true,
    modules: [
      {
        id: 'm5-1',
        title: 'Introduction to Educational Consulting',
        content: {
          video: 'https://example.com/video12',
          text: 'Educational consultants provide expert advice to schools, governments, NGOs, and other organizations on educational strategies, curriculum development, and program implementation. This module explores the consulting landscape and opportunities for education graduates...',
          resources: [
            { name: 'Educational Consulting Field Guide', url: '#' },
            { name: 'Consultant Value Proposition Template', url: '#' },
          ],
        },
      },
      {
        id: 'm5-2',
        title: 'Curriculum Development as a Career',
        content: {
          video: 'https://example.com/video13',
          text: 'Explore opportunities in curriculum design for schools, publishers, and educational content providers. Learn how to apply pedagogical knowledge to create effective learning materials and programs...',
          resources: [
            { name: 'Curriculum Developer Portfolio Guide', url: '#' },
            { name: 'Publishing Industry Connections', url: '#' },
          ],
        },
      },
    ],
  },
  {
    id: '6',
    title: 'HR Development & Talent Management',
    description:
      'Explore how your understanding of human development and learning can lead to successful careers in human resources.',
    thumbnail:
      'https://images.unsplash.com/photo-1529400971008-f566de0e6dfc?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    isRequired: false,
    isSuggested: true,
    modules: [
      {
        id: 'm6-1',
        title: 'HR Fundamentals for Educators',
        content: {
          video: 'https://example.com/video14',
          text: 'Human Resources development involves managing the human capital of an organization. Your background in education provides valuable insights into human development, motivation, and learning that are directly applicable to HR roles...',
          resources: [
            { name: 'HR Career Transition Guide', url: '#' },
            { name: 'Education to HR Skills Mapping', url: '#' },
          ],
        },
      },
      {
        id: 'm6-2',
        title: 'Talent Development Programs',
        content: {
          video: 'https://example.com/video15',
          text: 'Learn how organizations develop employee talent through structured programs, mentoring, and professional development initiatives. Discover how your background in curriculum design and assessment can be applied to talent development...',
          resources: [
            { name: 'Talent Development Program Design', url: '#' },
            { name: 'Employee Development Plan Template', url: '#' },
          ],
        },
      },
    ],
  },
  {
    id: '7',
    title: 'Non-Profit & NGO Leadership',
    description:
      'Discover how your education background can prepare you for impactful roles in educational non-profits and development organizations.',
    thumbnail:
      'https://images.unsplash.com/photo-1559027615-cd4628902d4a?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    isRequired: false,
    isSuggested: false,
    modules: [
      {
        id: 'm7-1',
        title: 'Educational NGOs in Africa',
        content: {
          video: 'https://example.com/video16',
          text: 'Explore the landscape of educational non-governmental organizations operating across Africa, their missions, impact areas, and the roles they offer for education graduates...',
          resources: [
            { name: 'African Education NGO Directory', url: '#' },
            { name: 'NGO Career Paths Guide', url: '#' },
          ],
        },
      },
      {
        id: 'm7-2',
        title: 'Program Development & Management',
        content: {
          video: 'https://example.com/video17',
          text: 'Learn how to design, implement, and manage educational programs for non-profits and NGOs, including needs assessment, stakeholder engagement, and impact evaluation...',
          resources: [
            { name: 'Program Design Framework', url: '#' },
            { name: 'Impact Measurement Toolkit', url: '#' },
          ],
        },
      },
    ],
  },
  {
    id: '8',
    title: 'Research & Policy Analysis',
    description:
      'Use your analytical skills and educational knowledge to influence educational policy and research.',
    thumbnail:
      'https://images.unsplash.com/photo-1434030216411-0b793f4b4173?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    isRequired: false,
    isSuggested: false,
    modules: [
      {
        id: 'm8-1',
        title: 'Educational Research Fundamentals',
        content: {
          video: 'https://example.com/video18',
          text: 'Discover how your background in education provides a foundation for careers in educational research, including understanding of research methodologies, data collection, and analysis...',
          resources: [
            { name: 'Research Methods Primer', url: '#' },
            { name: 'Data Analysis Tools Guide', url: '#' },
          ],
        },
      },
      {
        id: 'm8-2',
        title: 'Education Policy Analysis',
        content: {
          video: 'https://example.com/video19',
          text: 'Learn how educational policies are developed, analyzed, and implemented at local, national, and international levels. Explore career opportunities in policy think tanks, government agencies, and international organizations...',
          resources: [
            { name: 'Policy Brief Writing Guide', url: '#' },
            { name: 'Policy Analysis Framework', url: '#' },
          ],
        },
      },
    ],
  },
  {
    id: '9',
    title: 'Educational Publishing & Content Creation',
    description:
      'Explore careers in creating educational content for publishers, media companies, and digital platforms.',
    thumbnail:
      'https://images.unsplash.com/photo-1457369804613-52c61a468e7d?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    isRequired: false,
    isSuggested: false,
    modules: [
      {
        id: 'm9-1',
        title: 'The Educational Publishing Landscape',
        content: {
          video: 'https://example.com/video20',
          text: 'Explore the world of educational publishing, including textbooks, digital resources, assessment materials, and supplementary educational content...',
          resources: [
            { name: 'Publishing Industry Overview', url: '#' },
            { name: 'Content Creator Job Profiles', url: '#' },
          ],
        },
      },
      {
        id: 'm9-2',
        title: 'Creating Educational Content',
        content: {
          video: 'https://example.com/video21',
          text: 'Learn the principles of developing engaging, pedagogically sound educational content for various formats and audiences. Discover how your teaching background provides insights into effective content creation...',
          resources: [
            { name: 'Educational Content Style Guide', url: '#' },
            { name: 'Content Portfolio Development', url: '#' },
          ],
        },
      },
    ],
  },
  {
    id: '10',
    title: 'Building Your Career Transition Plan',
    description:
      'Develop a personalized roadmap to transition from education studies to your chosen alternative career path.',
    thumbnail:
      'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    isRequired: true,
    isSuggested: false,
    modules: [
      {
        id: 'm10-1',
        title: 'Self-Assessment & Career Alignment',
        content: {
          video: 'https://example.com/video22',
          text: 'Conduct a comprehensive assessment of your skills, interests, and values to identify which alternative career paths align best with your personal and professional goals...',
          resources: [
            { name: 'Career Values Assessment', url: '#' },
            { name: 'Skills Inventory Worksheet', url: '#' },
          ],
        },
      },
      {
        id: 'm10-2',
        title: 'Building Your Professional Brand',
        content: {
          video: 'https://example.com/video23',
          text: 'Learn how to position yourself for alternative careers by crafting a compelling resume, LinkedIn profile, and portfolio that translates your educational background into valuable professional qualifications...',
          resources: [
            { name: 'Resume Translation Guide', url: '#' },
            { name: 'LinkedIn Profile Optimizer', url: '#' },
          ],
        },
      },
      {
        id: 'm10-3',
        title: 'Networking & Job Search Strategies',
        content: {
          video: 'https://example.com/video24',
          text: 'Develop effective strategies for building professional networks, finding job opportunities, and successfully interviewing for roles in your chosen alternative career path...',
          resources: [
            { name: 'Networking Action Plan', url: '#' },
            { name: 'Interview Preparation Guide', url: '#' },
          ],
        },
      },
    ],
  },
]
